import moment from 'moment';
import React from 'react';

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any[]; // data can have any structure
  cssStyles?: React.CSSProperties;
  cssClasses?: string;
}

// Regular expression to match URL format
const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processValue = (value: any) => {
  // Handle Date Values: Format date values using parseDate function
  if (typeof value === 'string' && moment(value, true).isValid()) {
    return moment(value).format('MMM D, YYYY h:mm:ss A'); // parseDate is a function to format dates
  }

  // Handle URL Values
  if (typeof value === 'string' && urlRegex.test(value)) {
    return (
      <a href={value} target="_blank" rel="noopener noreferrer">
        {value}
      </a>
    ); // Open link in new tab
  }

  return value.toString();
};

const formatHeader = (header: string): string => {
  // Splitting the header by underscores and capitalizing each word
  return header
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const JsonToTable: React.FC<IProps> = ({ data, cssStyles, cssClasses }) => {
  // Extracting keys dynamically from the first item in the data array
  const keys = data.length > 0 ? Object.keys(data[0]) : [];

  return (
    <div
      style={{
        overflowX: 'auto',
        maxWidth: '100%',
        padding: '10px',
        width: '100%',
        maxHeight: '400px',
        overflowY: 'auto',
      }}
    >
      <table
        style={{ ...cssStyles, width: 'inherit' }} // Apply custom styles
        className={cssClasses} // Apply custom classNames
      >
        <thead>
          <tr>
            {keys.map((key, index) => (
              <th key={index} className="p-1">
                {formatHeader(key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, rowIndex) => (
            <tr key={rowIndex}>
              {keys.map((key, colIndex) => (
                <td key={colIndex} className="p-1">
                  {processValue(item[key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default JsonToTable;
